import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';

const getPrs = state => state.prs;

export const prMergedGroupedByDaySelector = createSelector(
  [getPrs],
  ({ items: prs }) => {
    if (!prs || !prs.length) {
      return null;
    }
    return {
      definition: {
        display_name: 'Pull Request Merged'
      },
      graphData: _(prs)
        .filter(({ state }) => state === 'merged')
        .groupBy(pr => moment(pr.merged_at).format(SEARCH_DATE_FORMAT))
        .map((prs, merged_at) => {
          return {
            target_date: merged_at,
            items: prs,
            total: prs.length
          };
        })
        .value()
    };
  }
);
